import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'notEmpty',
    pure: true,
    standalone: false
})
export class NotEmptyPipe implements PipeTransform {
  transform(value: object | [] | null): boolean {
    if (!value) {
      return false;
    }

    if (Array.isArray(value)) {
      return !!value.length;
    } else {
      return !!Object.keys(value).length;
    }
  }
}
